module.exports = __webpack_public_path__ + "static/media/HWLogo.021eea34.webp";


//////////////////
// WEBPACK FOOTER
// ./src/img/HWLogo.webp
// module id = 123
// module chunks = 0